"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowNodeViewModelFactory = void 0;
const index_1 = require("../Model/Activities/index");
const index_2 = require("../Model/Events/index");
const index_3 = require("../Model/Gateways/index");
const index_4 = require("./Activities/index");
const index_5 = require("./Events/index");
const index_6 = require("./Gateways/index");
exports.FlowNodeViewModelFactory = {
    getViewModel: (flowNodeModel, processModel) => {
        switch (flowNodeModel.constructor.name) {
            case index_1.BusinessRuleTask.name:
                return new index_4.BusinessRuleTaskViewModel(flowNodeModel, processModel);
            case index_1.CallActivity.name:
                return new index_4.CallActivityViewModel(flowNodeModel, processModel);
            case index_1.EmptyActivity.name:
                return new index_4.EmptyActivityViewModel(flowNodeModel, processModel);
            case index_1.ManualTask.name:
                return new index_4.ManualTaskViewModel(flowNodeModel, processModel);
            case index_1.ReceiveTask.name:
                return new index_4.ReceiveTaskViewModel(flowNodeModel, processModel);
            case index_1.ScriptTask.name:
                return new index_4.ScriptTaskViewModel(flowNodeModel, processModel);
            case index_1.SendTask.name:
                return new index_4.SendTaskViewModel(flowNodeModel, processModel);
            case index_1.ServiceTask.name:
                const serviceTask = flowNodeModel;
                return serviceTask.type === index_1.ServiceTaskType.external ?
                    new index_4.ExternalServiceTaskViewModel(serviceTask, processModel) :
                    new index_4.HttpServiceTaskViewModel(serviceTask, processModel);
            case index_1.SubProcess.name:
                return new index_4.SubProcessViewModel(flowNodeModel, processModel);
            case index_1.UserTask.name:
                return new index_4.UserTaskViewModel(flowNodeModel, processModel);
            case index_2.BoundaryEvent.name:
                return new index_5.BoundaryEventViewModel(flowNodeModel, processModel);
            case index_2.EndEvent.name:
                return new index_5.EndEventViewModel(flowNodeModel, processModel);
            case index_2.IntermediateCatchEvent.name:
                return new index_5.IntermediateCatchEventViewModel(flowNodeModel, processModel);
            case index_2.IntermediateThrowEvent.name:
                return new index_5.IntermediateThrowEventViewModel(flowNodeModel, processModel);
            case index_2.StartEvent.name:
                return new index_5.StartEventViewModel(flowNodeModel, processModel);
            case index_3.ComplexGateway.name:
                return new index_6.ComplexGatewayViewModel(flowNodeModel, processModel);
            case index_3.EventBasedGateway.name:
                return new index_6.EventBasedGatewayViewModel(flowNodeModel, processModel);
            case index_3.ExclusiveGateway.name:
                return new index_6.ExclusiveGatewayViewModel(flowNodeModel, processModel);
            case index_3.InclusiveGateway.name:
                return new index_6.InclusiveGatewayViewModel(flowNodeModel, processModel);
            case index_3.ParallelGateway.name:
                return new index_6.ParallelGatewayViewModel(flowNodeModel, processModel);
            default:
                return null;
        }
    },
};
//# sourceMappingURL=FlowNodeViewModelFactory.js.map